/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.OpencorporatesOrganization = factory(root.ForStractionServiceApi.ApiClient);
  }
}(this, function(ApiClient) {
  'use strict';




  /**
   * The OpencorporatesOrganization model module.
   * @module model/OpencorporatesOrganization
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new <code>OpencorporatesOrganization</code>.
   * @alias module:model/OpencorporatesOrganization
   * @class
   */
  var exports = function() {
    var _this = this;

















  };

  /**
   * Constructs a <code>OpencorporatesOrganization</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/OpencorporatesOrganization} obj Optional instance to populate.
   * @return {module:model/OpencorporatesOrganization} The populated <code>OpencorporatesOrganization</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('BranchStatus')) {
        obj['BranchStatus'] = ApiClient.convertToType(data['BranchStatus'], 'String');
      }
      if (data.hasOwnProperty('CompanyNumber')) {
        obj['CompanyNumber'] = ApiClient.convertToType(data['CompanyNumber'], 'String');
      }
      if (data.hasOwnProperty('CompanyType')) {
        obj['CompanyType'] = ApiClient.convertToType(data['CompanyType'], 'String');
      }
      if (data.hasOwnProperty('CreatedAt')) {
        obj['CreatedAt'] = ApiClient.convertToType(data['CreatedAt'], 'Date');
      }
      if (data.hasOwnProperty('CurrentStatus')) {
        obj['CurrentStatus'] = ApiClient.convertToType(data['CurrentStatus'], 'String');
      }
      if (data.hasOwnProperty('DissolutionDate')) {
        obj['DissolutionDate'] = ApiClient.convertToType(data['DissolutionDate'], 'Date');
      }
      if (data.hasOwnProperty('Inactive')) {
        obj['Inactive'] = ApiClient.convertToType(data['Inactive'], 'Boolean');
      }
      if (data.hasOwnProperty('IncorporationDate')) {
        obj['IncorporationDate'] = ApiClient.convertToType(data['IncorporationDate'], 'Date');
      }
      if (data.hasOwnProperty('JurisdictionCode')) {
        obj['JurisdictionCode'] = ApiClient.convertToType(data['JurisdictionCode'], 'String');
      }
      if (data.hasOwnProperty('Name')) {
        obj['Name'] = ApiClient.convertToType(data['Name'], 'String');
      }
      if (data.hasOwnProperty('OpencorporatesUrl')) {
        obj['OpencorporatesUrl'] = ApiClient.convertToType(data['OpencorporatesUrl'], 'String');
      }
      if (data.hasOwnProperty('RegistryUrl')) {
        obj['RegistryUrl'] = ApiClient.convertToType(data['RegistryUrl'], 'String');
      }
      if (data.hasOwnProperty('RetrievedAt')) {
        obj['RetrievedAt'] = ApiClient.convertToType(data['RetrievedAt'], 'Date');
      }
      if (data.hasOwnProperty('UpdatedAt')) {
        obj['UpdatedAt'] = ApiClient.convertToType(data['UpdatedAt'], 'Date');
      }
      if (data.hasOwnProperty('RegisteredAddressInFull')) {
        obj['RegisteredAddressInFull'] = ApiClient.convertToType(data['RegisteredAddressInFull'], 'String');
      }
      if (data.hasOwnProperty('ID')) {
        obj['ID'] = ApiClient.convertToType(data['ID'], 'Integer');
      }
    }
    return obj;
  }

  /**
   * @member {String} BranchStatus
   * @default ''
   */
  exports.prototype['BranchStatus'] = '';
  /**
   * @member {String} CompanyNumber
   * @default ''
   */
  exports.prototype['CompanyNumber'] = '';
  /**
   * @member {String} CompanyType
   * @default ''
   */
  exports.prototype['CompanyType'] = '';
  /**
   * @member {Date} CreatedAt
   */
  exports.prototype['CreatedAt'] = undefined;
  /**
   * @member {String} CurrentStatus
   * @default ''
   */
  exports.prototype['CurrentStatus'] = '';
  /**
   * @member {Date} DissolutionDate
   */
  exports.prototype['DissolutionDate'] = undefined;
  /**
   * @member {Boolean} Inactive
   * @default false
   */
  exports.prototype['Inactive'] = false;
  /**
   * @member {Date} IncorporationDate
   */
  exports.prototype['IncorporationDate'] = undefined;
  /**
   * @member {String} JurisdictionCode
   * @default ''
   */
  exports.prototype['JurisdictionCode'] = '';
  /**
   * @member {String} Name
   * @default ''
   */
  exports.prototype['Name'] = '';
  /**
   * @member {String} OpencorporatesUrl
   * @default ''
   */
  exports.prototype['OpencorporatesUrl'] = '';
  /**
   * @member {String} RegistryUrl
   * @default ''
   */
  exports.prototype['RegistryUrl'] = '';
  /**
   * @member {Date} RetrievedAt
   */
  exports.prototype['RetrievedAt'] = undefined;
  /**
   * @member {Date} UpdatedAt
   */
  exports.prototype['UpdatedAt'] = undefined;
  /**
   * @member {String} RegisteredAddressInFull
   * @default ''
   */
  exports.prototype['RegisteredAddressInFull'] = '';
  /**
   * @member {Integer} ID
   * @default 0
   */
  exports.prototype['ID'] = 0;



  return exports;
}));


